const styles = {
    menuItem: {
        color: '#666',
        fontSize: 14,
        height: 20
    },
    excelIcon:{
        backgroundColor: 'transparent',
        borderRadius: 0,
        verticalAlign: 'initial'
    },
    smallIcon: {
        width: 20,
        height:20,

      },
      small: {
        width: 30,
        height: 30,
        padding: 0
      },
      iconFlatButton:{
          padding: 0,
          margin: 0,
          minWidth: 30,
          width: 40,
          height: 48
      }
  };

  export default styles;


// WEBPACK FOOTER //
// ./src/components/table/styles/LinkToDetailsCellRenderStyles.js